import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import { ApiStatusTypeEnum } from "../../../enumeration/ApiStatusTypeEnum";
import * as requestToApi from "./CompanyGameCRUD";
import { companyGameSlice } from "./CompanyGameSlice";

const { actions } = companyGameSlice;

export const fetchCompanyList = () => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .postAgent22Api({ action: "corecompanylist" })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.companyListFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchCompanyList");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const fetchCompanyGame = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.LIST }));

  return requestToApi
    .postAgent22Api({ action: "coreallcompanygame", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.companyGameFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchCompanyGame");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.LIST })
      );
      throw error;
    });
};

export const fetchGameDetail = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent22Api({ action: "coreeditcompanygameUI", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.gameDetailFetched({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: fetchGameDetail");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const createCompanyGame = (queryParams, url) => (dispatch) => {
  return requestToApi
    .createGame(queryParams, url)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          return response;
        }
      } else {
        throw new Error("Error api: createGame");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const manageGameRecord = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent22Api(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          if (parseInt(response.data.code) === ApiStatusTypeEnum.SUCCESS)
            dispatch(actions.companyGameFetched({ data: response.data }));
          else dispatch(actions.gameManaged());
          return response;
        }
      } else {
        throw new Error("Error api: manageGameRecord");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const checkGameCodeExist = (queryParams) => (dispatch) => {
  return requestToApi
    .postAgent22Api({ action: "corecheckgamecodeexist", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          return response;
        }
      } else {
        throw new Error("Error api: checkGameCodeExist");
      }
    })
    .catch((error) => {
      throw error;
    });
};

export const deleteCompanyGame = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent22Api({ action: "coredeletecompanygame", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          if (parseInt(response.data.code) === ApiStatusTypeEnum.SUCCESS)
            dispatch(actions.companyGameFetched({ data: response.data }));
          else dispatch(actions.gameManaged());
          return response;
        }
      } else {
        throw new Error("Error api: deleteCompanyGame");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const updateRecommendGameList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent23Api({ action: "updaterecommentgame", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.gameManaged());
          return response;
        }
      } else {
        throw new Error("Error api: deleteCompanyGame");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};

export const publishPendingGame = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent22Api({ action: "corepublishpendgame", ...queryParams })
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.gameManaged());
          return response;
        }
      } else {
        throw new Error("Error api: publishPendingGame");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
